import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import {
    onStartChatViaSipProtocol,
    onStartCallViaSipProtocol,
    onStartChatViaImAddressUrl,
    onStartCallViaPhoneUrl,
} from 'owa-nova-actions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaTeamsIntegration" */ './lazyIndex'),
    { name: 'OwaTeamsIntegration' }
);

registerLazyOrchestrator(onStartChatViaSipProtocol, lazyModule, m => m.startChatViaSipProtocol);
registerLazyOrchestrator(onStartCallViaSipProtocol, lazyModule, m => m.startCallViaSipProtocol);
registerLazyOrchestrator(onStartCallViaPhoneUrl, lazyModule, m => m.startCallViaPhoneUrl);
registerLazyOrchestrator(onStartChatViaImAddressUrl, lazyModule, m => m.startChatViaImAddressUrl);

// Lazily-loaded Components
export const lazyChatAroundEmail: LazyAction<typeof lazyIndex.chatAroundEmail, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.chatAroundEmail);
export const lazyShareEmailToTeamsChat: LazyAction<
    typeof lazyIndex.shareEmailToTeamsChat,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.shareEmailToTeamsChat);

export const lazyRunTeamsControlChecksSync: LazyAction<
    typeof lazyIndex.runTeamsControlChecksSync,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.runTeamsControlChecksSync);
